/**
 * Day Diary v2 — binding User-visible copy table (task 237, D4 / AC10).
 *
 * This module is the SINGLE SOURCE OF TRUTH for the five assistant-voice
 * strings in the v2 surface. The card components and the `useDayDiary` hook
 * consume these constants; the AC10 test asserts they render verbatim.
 *
 * Assistant voice only — the subject is "I" or descriptive, never "the
 * system"; never "cannot"; never any leaked operator detail (verification
 * script names, org ids, status codes). A future product-copy pass may
 * refine the wording — change it HERE, not at the call sites.
 *
 * CROSS-TASK CONTRACT (verbatim equality, not a shared import — the backend
 * is a separate npm package and cannot import this module):
 *
 *   - DAY_DIARY_IN_FLIGHT — must match the 409 body hardcoded in task 235's
 *     `DAY_DIARY_V2_IN_FLIGHT_BODY` (web/src/routes/reports.ts).
 *   - PERSONAL_PROJECT_MISCONFIG — must match the 500 body hardcoded in task
 *     236's `PERSONAL_PROJECT_MISSING_BODY` (web/src/routes/suggestions.ts).
 *
 * Both backend strings carry a `// source: task 237 copy table` comment.
 * Keep all three in sync verbatim.
 */
export const DAY_DIARY_COPY = {
  /** Unattributable card label — suggestion `kind='unattributable'`. */
  UNATTRIBUTABLE_LABEL: "I'm not sure where this fits",

  /** OCR section header — above the `observed` prose + `observed_text` chips. */
  OCR_SECTION_HEADER: 'What I noticed on screen',

  /** Low-signal frame — vision returned `verdict='no_signal'` (app_chrome_only). */
  LOW_SIGNAL_FRAME: 'Not much was visible in this moment.',

  /** In-flight regen 409 — POST `/day-diary-v2?force=true` on a non-terminal run. */
  DAY_DIARY_IN_FLIGHT:
    'Your previous diary is still being prepared. Give it a moment and try again.',

  /** Personal-project misconfig 500 — PersonalProjectMissingError. */
  PERSONAL_PROJECT_MISCONFIG:
    'Something on our side is misconfigured for your account. The team has been notified.',
} as const;

export type DayDiaryCopyKey = keyof typeof DAY_DIARY_COPY;
